import React from "react";
import { observer } from "mobx-react";

const SurveyGridHeader = observer((props) => {
    const { customLayout = false, columnWidths = [] } = props;

    const headerClass = "gridHeadings2";

    if (customLayout) {
        return (
            <thead id={props.id} className={headerClass}>
                {props.children}
            </thead>
        );
    } else {
        return (
            <thead id={props.id}>
                <tr role="row">
                    {React.Children.map(props.children, (child, index) => {
                        if (child?.props["hidden"]) return null;

                        const w = columnWidths[index];

                        return (
                            <th
                                className={headerClass}
                                key={index}
                                style={w ? {width: w } : undefined}
                                role="columnheader"
                                scope="col"
                            >
                                {child}
                            </th>
                        );
                    })}
                </tr>
            </thead>
        );
    }
});

export default SurveyGridHeader;
